<template>
  <div class='layout'>
    <div class='header'>
      <!-- banner -->
      <div class='banner'>
        <img src='../assets/imgs/logo_icon.png' alt='' class='logo-icon'>
        <img src='../assets/imgs/logo_name.png' alt='' class='logo-name'>
      </div>
      <!-- 导航 -->
      <div class='nav-bar'>
        <a v-for='(item,index) in navs' :key='index' :class='{"active":item.label === activeBar}' class='item' href='javascript:;' @click='goRouter(item)'>{{ item.name }}</a>
      </div>
    </div>
    <!-- 主内容区 -->
    <div class='content'>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navs: [
        { label: 'TEXTBOOK', name: '教材征订', path: '/ordersearch' },
        { label: 'PRESS', name: '出版社数据', path: '/press' },
        { label: 'LIBRARY', name: '图书馆', path: '/library' },
        { label: 'MY', name: '个人中心', path: '/my' }
      ]
    }
  },
  computed: {
    activeBar() {
      return this.$store.state.activeBar
    }
  },
  methods: {
    goRouter(item) {
      let path = item.path
      let label = item.label
      this.$router.push({path})
      this.setActiveBar(label)
    }
  }

}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.layout {
  .header {
    width: 100%;
    height: 200px;

    .banner {
      width: 100%;
      min-width: 1200px;
      height: 140px;
      display: flex;
      flex-direction: row;
      background-color: @blue-d;
      align-items: baseline;
      padding-left: 55px;
      padding-top: 32px;
      box-sizing: border-box;

      .logo-icon {
        width: 94px;
        height: 72px;
      }
      .logo-name {
        width: 274px;
        height: 38px;
        margin-left: 30px;
      }
    }

    .nav-bar {
      width: 1200px;
      height: 60px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;

      .item {
        width: 180px;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        color: #4d4d4d;
        background: #cccccc;
        text-align: center;
        cursor: pointer;

        &.active {
          color: #ffffff;
          background-color: @blue-d;
        }
      }
    }
  }
  .content {
    width: 1200px;
    margin: 30px auto 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout.vue